import { JurisdictionDepartments } from './jurisdictions';
import { MatterFileType } from './matter';

export const ClientSubType = {
	ALL: 'all',
	CORPORATE: 'corporate',
	INDIVIDUAL: 'individual',
} as const;

export const EmailRecipientType = {
	ALL: 'all',
	CLIENT: 'client',
	JURISDICTION: 'jurisdiction',
	PACKAGE_EMAIL: 'package_email',
} as const;

export type ClientSubType = (typeof ClientSubType)[keyof typeof ClientSubType];
export type EmailRecipientType =
	(typeof EmailRecipientType)[keyof typeof EmailRecipientType];

export interface EmailRecipient {
	type: EmailRecipientType;
	subType?: ClientSubType | JurisdictionDepartments;
}

export interface GlobalEmailTemplateMetadata {
	id?: string;
	templateName: string;
	emailRecipientType: EmailRecipientType | null;
	emailRecipientSubType: ClientSubType | JurisdictionDepartments | null;
	fileType: MatterFileType;
	default: boolean;
	createdBy: string;
	createdAt: number;
	updatedAt: number;
	versionId: string;
	source: 'business' | 'global';
}

export interface GlobalEmailTemplate {
	id?: string;
	subject: string;
	htmlMessage: string;
	attachments?: EmailAttachment[];
	createdBy: string;
	createdAt: number;
}

export interface GlobalEmailRequest {
	recipients: EmailAddress[];
	subject: string;
	htmlMessage: string;
	attachments?: EmailAttachment[];
	fromEmail?: string;
	fromName?: string;
	cc?: EmailAddress[];
	bcc?: EmailAddress[];
}

export interface EmailAddress {
	email: string;
	displayName?: string;
}

export interface EmailAttachment {
	fileName: string;
	file: Buffer;
}
